import React, {useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import SectionHeader from "components/dashboard/SectionHeader";

import TopTableHeaderContainer from "../../../TopTablesComponents/TopTableHeaderContainer";
import RetailerStockAlertTable from "./components/RetailerStockAlertTable";

import {greyishBlue100} from "assets/jss/main";

import {getRetailerStockAlerts} from "api/dashboard/retailerStockAlerts";

import useScrollTrigger from "hooks/useScrollTrigger";

import {DateRangePickerContext} from "contexts/DateRangePickerContext";

function TopRetailerStockAlert({ currency }) {
    const { startDate, endDate, dateChangedTrigger } = useContext(DateRangePickerContext);

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);

    const [sectionRef, triggered] = useScrollTrigger(dateChangedTrigger);

    useEffect(() => {
        if (!triggered || !startDate || !endDate) {
            return;
        }

        const start = startDate.format("Y-M-D");
        const end = endDate.format("Y-M-D");

        // a slower response for a previous date range must not overwrite the current one
        let cancelled = false;

        setData(null);
        setLoading(true);
        getRetailerStockAlerts(start, end)
            .then(res => !cancelled && setData(res?.retailerStockAlerts ?? []))
            .catch(() => !cancelled && setData([]))
            .finally(() => !cancelled && setLoading(false));

        return () => {
            cancelled = true;
        };
    }, [triggered]);

    return (
        <div ref={sectionRef} style={{ marginBottom: 24 }}>
            <TopTableHeaderContainer>
                <SectionHeader
                    title={<FormattedMessage id="dashboard.retailerStockAlerts.title" />}
                    subtitle={<FormattedMessage id="dashboard.retailerStockAlerts.subtitle" />}
                />
            </TopTableHeaderContainer>

            <div
                style={{
                    backgroundColor: "#fff",
                    borderRadius: "0px 0px 12px 12px",
                    border: `1px solid ${greyishBlue100}`,
                    borderTop: 'none',
                    margin: 0,
                }}
            >
                <RetailerStockAlertTable data={data} loading={loading} currency={currency} />
            </div>
        </div>
    );
}

TopRetailerStockAlert.propTypes = {
    currency: PropTypes.string
};

export default TopRetailerStockAlert;
